import { render } from "./LearnerQuiz.vue?vue&type=template&id=833396da"
import script from "./LearnerQuiz.vue?vue&type=script&lang=js"
export * from "./LearnerQuiz.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__